var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team-members"},_vm._l((_vm.members),function(member){return _c('TeamMember',{key:member.id,attrs:{"member":member}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }